import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import unifiedTabsSx from 'components/tabs/unifiedTabsSx';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Link, useLocation, useParams } from 'react-router-dom';

const messages = defineMessages({
  overTime: { id: 'analyze.tab.overTime', defaultMessage: 'Over time' },
  delivery: { id: 'analyze.tab.delivery', defaultMessage: 'Delivery' },
  snapshot: { id: 'analyze.tab.snapshot', defaultMessage: 'Snapshot' },
  breakdown: { id: 'analyze.tab.breakdown', defaultMessage: 'Breakdown' },
  questions: { id: 'analyze.tab.questions', defaultMessage: 'Follow-up questions' },
});

const tabs = [
  { key: 'overTime', path: '' },
  { key: 'delivery', path: 'delivery' },
  { key: 'snapshot', path: 'snapshot' },
  { key: 'breakdown', path: 'breakdown' },
  { key: 'questions', path: 'questions' },
];

function AnalyzeSubNav() {
  const { id: surveyId } = useParams();
  const { pathname, search } = useLocation();
  const { formatMessage } = useIntl();
  const base = `/surveys/${surveyId}/analyze`;

  const activeIndex = tabs.findIndex(tab => {
    const href = tab.path ? `${base}/${tab.path}` : base;
    return pathname === href || (tab.path && pathname.startsWith(`${base}/${tab.path}`));
  });

  return (
    <Tabs value={activeIndex === -1 ? 0 : activeIndex} sx={{ mb: 3, ...unifiedTabsSx }}>
      {tabs.map(tab => {
        const href = tab.path ? `${base}/${tab.path}` : base;
        return (
          <Tab
            key={tab.key}
            label={formatMessage(messages[tab.key])}
            component={Link}
            to={{ pathname: href, search }}
          />
        );
      })}
    </Tabs>
  );
}

export default AnalyzeSubNav;
